export const REFERRED_LEADS_REPORT_LOADING = 'REFERRED_LEADS_REPORT_LOADING';
export const REFERRED_LEADS_REPORT_SUCCESS = 'REFERRED_LEADS_REPORT_SUCCESS';
export const REFERRED_LEADS_REPORT_ERROR = 'REFERRED_LEADS_REPORT_ERROR';
